/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IDisposable } from '../../../base/common/lifecycle.js';
import { ViewportData } from '../../common/viewLayout/viewLinesViewportData.js';
import { ViewLineOptions } from '../viewParts/viewLines/viewLineOptions.js';
import { IGlyphRasterizer } from './raster/raster.js';

export const enum BindingId {
	GlyphInfo,
	Cells,
	TextureSampler,
	Texture,
	LayoutInfoUniform,
	AtlasDimensionsUniform,
	ScrollOffset,
}

export interface IGpuRenderStrategy extends IDisposable {
	readonly type: string;
	readonly wgsl: string;
	readonly bindGroupEntries: GPUBindGroupEntry[];
	readonly glyphRasterizer: IGlyphRasterizer;

	/**
	 * Resets the render strategy, clearing all data and setting up for a new frame.
	 */
	reset(): void;
	update(viewportData: ViewportData, viewLineOptions: ViewLineOptions): number;
	draw(pass: GPURenderPassEncoder, viewportData: ViewportData): void;
}
